/* eslint-disable */

import { useState } from "react";
import RaindropButton from "../raindrop-button/raindrop-button.tsx";

const DropdownBody = ({ children, onBlur }) => {
  return (
    <div
      className={`p-2 fixed w-fit z-10 rounded-lg border shadow-lg 
        shadow-slate-200 dark:shadow-none
      bg-color-background-secondary dark:bg-color-dark-background-secondary
      border-color-border-secondary dark:border-color-dark-border-secondary`}
    >
      {children}
    </div>
  );
};

const RaindropDropdown = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <RaindropButton
        icon="fa-ellipsis"
        isHidingTitle={true}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      />
      {isOpen && <DropdownBody children={children} />}
    </div>
  );
};

export default RaindropDropdown;
